import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faScrewdriverWrench } from '@fortawesome/free-solid-svg-icons';
import { StubWrap } from './styled';
import { PageHeader } from '../../components';

/**
 * Placeholder page for nav items whose full experience is not built yet.
 * Rendered for the stubbed sidebar destinations (Prospects, Tenants, Owners,
 * Properties, Scheduling, Vendors, Reports, Automations).
 */
export default function Stub({ title, subtitle, icon = faScrewdriverWrench }) {
  return (
    <div>
      <PageHeader title={title} subtitle={subtitle} />
      <StubWrap>
        <div className="stub-icon">
          <FontAwesomeIcon icon={icon} />
        </div>
        <div className="stub-title">{title} is on the way</div>
        <div className="stub-sub">
          This section is stubbed out. The full workflow will land in a later pass.
        </div>
      </StubWrap>
    </div>
  );
}
